import styled from 'styled-components';

export const Legend = styled.div`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 4px;
  background-color: ${(props) => props.color};
`;
